<template>
    <v-app>
        <!-- <h3 class="display-1">Company List</h3> -->
        
        <v-container
            fill-height
            fluid
            grid-list-xl
        >
        
            <v-layout wrap justify-center> 
                <v-flex xs10>
              <v-text-field label="Search Company" v-model="searchCompany" outline ></v-text-field>
                <v-btn color="success" @click="exportToCSV(csvData)">CSV</v-btn>
                <v-btn @click="exportToPDF()" dark>PDF</v-btn>
                <table id="companylist" v-show="false">
                    <tr>
                        <td>Name</td>
                        <td>Insurance</td>
                        <td>Email</td>
                        <td>Remarks</td>
                        <td>PIC</td>
                    </tr>
                    <tr v-for="company in companies" :key="company['key']">
                        <td>{{ company.name }}</td>
                        <td>{{ company.ins }}</td>
                        <td>{{ company.email }}</td>
                        <td>{{ company.remarks }}</td>
                        <td>{{ company.pic }}</td>
                    </tr>
                </table>  
                </v-flex>
                <v-flex xs12 sm5  md4 lg3>
                    <material-add-card
                        title="Add New Company"
                        big-icon="mdi-plus"
                        @click="addCompanyModal = true"
                    >
                    </material-add-card>
                </v-flex>
                <v-flex
                    xs12
                    sm5                    
                    md4
                    lg3
                    v-for="company in filteredCompany" :key="company['id']">
                    <!-- lots of props -->
                    <material-stats-card
                    title="Title"
                    :sub-text="company.name"
                    sub-text-color="black"
                    sub-icon-color="grey"
                    big-icon-color="teal"
                    sub-icon-type="menu"
                    sub-icon="mdi-information"
                    big-icon="mdi-domain"
                    :dropdown="dropdown"
                    @viewCompany="viewCompany(company)"
                    @viewPatient="viewPatient(company.id)"
                     @viewAnalytics="viewAnalytics(company.id)"
                     @viewAnalytics2="viewAnalytics2(company.id)"
                    />
                </v-flex>
                
                
                <Modal :dialog="companyModal" @close="companyModal = false; offEditMode()">
                    <div slot="title">
                        {{ selectedCompany.name }}
                    </div>
                    <div slot="body" v-if="!editMode">
                        <p class="body-2">Address: {{ selectedCompany.address }}</p>
                        <p class="body-2">Email: {{ selectedCompany.email }}</p>
                        <p class="body-2">Insurance: {{ selectedCompany.ins }}</p>
                        <p class="body-2">Contact: {{ selectedCompany.contact }}</p>
                        <p class="body-2">Person In Charge: {{ selectedCompany.pic }}</p>
                        <p class="body-2">Remark: {{ selectedCompany.remark }}</p>
                          <p class="body-2">Require Assesment: {{ selectedCompany.assessment }}</p>
                    </div>
                    <div slot="body" v-if="editMode">
                  <!--      <v-form v-model="validateEditCompany" ref="editCompanyForm">   -->
                      <v-form  ref="editCompanyForm"> 
                            <p class="body-2">Company Name: 
                                <v-text-field v-model="editingCompany.name" :rules="nameRules"></v-text-field>
                            </p>
                            <p class="body-2">Address: 
                                <v-text-field v-model="editingCompany.address" ></v-text-field>
                            </p>
                            <p class="body-2">Email: 
                                <v-text-field v-model="editingCompany.email" :rules="emailRules"></v-text-field>
                            </p>
                            <p class="body-2">Insurance:
                                <v-text-field v-model="editingCompany.ins" :rules="normalRules"></v-text-field>
                            </p>
                            <p class="body-2">Contact:
                                <v-text-field v-model="editingCompany.contact" :rules="normalRules"></v-text-field>
                            </p>
                            <p class="body-2">Person In Charge:
                                <v-text-field v-model="editingCompany.pic" :rules="normalRules"></v-text-field>
                            </p>
                            <p class="body-2">Remark:
                                <v-textarea v-model="editingCompany.remark"></v-textarea>
                            </p>
                               <p class="body-2">Require Assesment:
                        <v-select  :items="['YES','NO']"  v-model="editingCompany.assessment" ></v-select>
                            </p>
                        </v-form>
                    </div>
                    <div slot="footer">
                        <v-btn color="warning" v-if="!editMode" @click="onEditMode()">Edit</v-btn>
                        <v-btn color="danger" v-if="!editMode" @click="deleteCompany(selectedCompany.id)">Delete</v-btn>
                        <v-btn color="success" v-if="editMode" @click="editCompany(editingCompany.id)">
                            Save
                        </v-btn>
                        <v-btn color="black" v-if="editMode" @click="offEditMode()">Cancel</v-btn>
                    </div>
                </Modal>
                <Modal :dialog="addCompanyModal" @close="addCompanyModal = false" id="addcompanymodal">
                    <div slot="title">
                        Add New Company
                    </div>
                    <div slot="body">
                        <v-form>
                            <v-container>
                                <v-form v-if="!isSubmitted" ref="addCompanyForm" v-model="validateAddCompany">
                                    <v-text-field label="Company Name" v-model="name" :rules="nameRules" required></v-text-field>
                                    
                                    <v-text-field label="Email" v-model="email" :rules="emailRules" required></v-text-field>
                                    
                                    <v-text-field label="Address" v-model="address" :rules="normalRules" required></v-text-field>
                                
                                    <v-text-field label="Person In Charge" v-model="pic" :rules="normalRules" required></v-text-field>
                                
                                    <v-text-field label="Insurance" v-model="ins" :rules="normalRules" required></v-text-field>
    
                                    <v-text-field label="Contact" v-model="contact" :rules="normalRules" required></v-text-field>
                                
                                    <v-textarea label="Remark" v-model="remark"></v-textarea>
                                <v-select  label="Require Assessment" :items="['YES','NO']"  v-model="assessment" required></v-select>
                                </v-form>
                                <span v-else>
                                    <p class="headline">You have successfully added new company!</p>
                                </span>
                            </v-container>
                        </v-form>
                    </div>
                    <div slot="footer">
                        <v-btn @click="addCompany()"  v-show="!isSubmitted" color="success">Add Company</v-btn>
                        <v-btn @click="addCompanyModal = false"  color="red">Cancel</v-btn>
                        <v-btn @click="addCompanyModal = false; isSubmitted = false" v-show="isSubmitted" color="success">Ok</v-btn>
                    </div>
                </Modal>
            </v-layout>
        </v-container>
    </v-app>
</template>
<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import db from '@/components/firebase.init';
export default {
    data(){
        return{
            companies:[],
            selectedCompany: {},
            editingCompany: {},
            editMode: false,
            isUpdating: false,
            dropdown:[
                        {
                          title: 'View Details',
                          action: 'viewCompany'
                        }, 
                        {
                            title: 'Patient List',
                            action: 'viewPatient'
                        },
                          {
                            title: 'Analytics',
                            action: 'viewAnalytics'
                        },
                         {
                            title: 'Analytics (Export)',
                            action: 'viewAnalytics2'
                        }
                    ],
            companyModal: false,
            addCompanyModal: false,
            isSubmitted: false,
            validateAddCompany: false,
            validateEditCompany: false,
            nameRules:[
                v => (v && v.length <= 44) || 'Name must be less than 44 characters',
                v => !!v || 'Field is required'],
            normalRules: [v => !!v || 'Field is required'],
            emailRules: [ 
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            searchCompany: '',
            name: '',
            email: '',
            assessment:'YES',
            address: '',
            pic: '',
            ins: '',
            contact: '',
            remark: ''
        }
    },
    methods:{
        offEditMode(){
            this.editingCompany = {};
            this.editMode = false;
        },
        onEditMode(){
            this.editingCompany = Object.assign({},this.selectedCompany);
            this.editMode = true;
        },
        deleteCompany(id){
            if(confirm('Are you sure you want to delete this?')){
                db.collection('company').doc(id).delete()
                .then(()=>{
                    this.companyModal = false;
                    this.getCompany();
                })
            }
        },
        getCompany(){
            this.companies = [];
            db.collection('company').get()
            .then(doc =>{
                doc.forEach(item =>{
                    let document = {id: item.id}
                    Object.assign(document, item.data());
                    this.companies.push(document);
                })
            })
        },
        editCompany(id){
            this.isUpdating = true;
       //     if(this.$refs.validateEditCompany.validate()){
                db.collection('company').doc(id).update({
                        name: this.editingCompany.name,
                        email: this.editingCompany.email,
                        address: this.editingCompany.address,
                        pic: this.editingCompany.pic,
                        ins: this.editingCompany.ins,
                        contact: this.editingCompany.contact,
                        remark: this.editingCompany.remark,
                        assessment:this.editingCompany.assessment
                })
                .then(()=>{
                    this.isUpdating = false;
                    this.selectedCompany = Object.assign({}, this.editingCompany);
                    this.offEditMode()
                    this.getCompany();
                })
                .catch(e =>{
                    alert(e);
                    this.isUpdating = false
                })
       //     }
        },
        addCompany(){
            if(this.$refs.addCompanyForm.validate()){
                db.collection('company').add(
                    {
                        name: this.name,
                        email: this.email,
                        pic: this.pic,
                        ins: this.ins,
                        contact: this.contact,
                        remark: this.remark,
                    assessment:this.assessment
                    }
                )
                .then(()=>{
                    this.getCompany();
                    this.isSubmitted = true;
                    this.name = ''
                    this.email = ''
                    this.address = ''
                    this.pic = ''
                    this.ins = ''
                    this.contact = ''
                    this.remark = ''
                    this.assessment = 'YES'
                    // this.addCompanyModal = false;
                })
            }
        },
        viewPatient(id){
            this.$router.push('/patient/'+id);
        },
            viewAnalytics(id){
            this.$router.push('/analytics/'+id);
        },
            viewAnalytics2(id){
            this.$router.push('/analytics2/'+id);
        },
        viewCompany(company){
            this.selectedCompany = company;
            this.companyModal = true;
        },
        exportToCSV(data){
            let csvContent = "data:text/csv;charset=utf-8,";
            console.log(data);
            // csvContent += Object.keys(data[0]).join(";")
            csvContent +=[
                Object.keys(data[0]).join(";"),
                ...data.map(item =>Object.values(item).join(";"))
            ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "")
            console.log(csvContent);
            const doc = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", doc);
            link.setAttribute("download", "companylist.csv");
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link)
        },
        exportToPDF(){
            var doc = new jsPDF({orientation: 'landscape'});
            let columns = [];
            let rows = [];
            columns.push(Object.keys(this.companies[0]))
            this.companies.map(item => {
                rows.push(Object.values(item))
            })
            doc.autoTable(
                {
                    head: columns,
                    body: rows
                }
            );
            doc.save("companylist.pdf")
        }
    },
    computed:{
        filteredCompany(){
            if(this.searchCompany){
                let result = this.searchCompany.toUpperCase()
                return this.companies.filter(item =>{
                    let name = item.name.toUpperCase();
                    return name.match(result);
                })
            }
            else{
                return this.companies
            }
        },
        csvData(){
            return this.companies
        }
    },
    components:{
        
    },
    beforeMount(){
        this.getCompany();
    }
}
</script>

<style scoped>

.newcompany {
    max-width: 800px;
}

</style>
